<template>
  <div class="RecordBox">
    <div class="Record"
			v-loading="loading"
			element-loading-text="加载中..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(255, 255, 255, 1)"
		>
			<template v-if="!loading">
				<div class="_RecordTop">
					<p class="_label">我的账户</p>
					<p class="_Record_p1">当前账户余额（元）</p>
					<p class="_Record_p2" v-if="infoData">{{infoData.balance_alias}}</p>
					<p class="_Record_p_button" @click.stop="jumpTopup()">立即充值</p>
				</div>
				<div class="_RecordBot">
					<p class="_label">消费充值</p>
					<!-- Tab 切换 -->
					<div class="_tabBox">
						<div 
							v-for="(tab, index) in tabList" 
							:key="index"
							:class="['_tab', activeTab === index ? '_active' : '']"
							@click.stop="switchTab(index)"
						>
							{{ tab.name }}
						</div>
					</div>
					<div class="_cont">
						<el-table 
						:key="activeTab"
						:data="list" 
						style="width: 100%;"
						class="clean-table"
						@selection-change="handleSelectionChange">
							<!-- 充值记录列 (type=1) -->
							<template v-if="activeTab === 0">
								<el-table-column
									prop="no"
									align="center"
									label="订单号"
									min-width="160">
								</el-table-column>
								<el-table-column
									prop="amount"
									align="center"
									label="充值金额"
									width="90">
								</el-table-column>
								<el-table-column
									prop="before"
									align="center"
									label="充值前余额"
									width="90">
								</el-table-column>
								<el-table-column
									prop="after"
									align="center"
									label="充值后余额"
									width="90">
								</el-table-column>
								<el-table-column
									prop="pay_type"
									align="center"
									label="充值方式"
									width="90">
								</el-table-column>
								<el-table-column
									prop="pay_status"
									align="center"
									label="支付状态"
									width="80">
								</el-table-column>
								<el-table-column
									prop="created_at"
									align="center"
									label="订单创建时间"
									min-width="160">
								</el-table-column>
							</template>
							<!-- 消费订单列 (type=2) -->
							<template v-if="activeTab === 1">
								<el-table-column
									prop="no"
									align="center"
									label="订单号"
									min-width="160">
								</el-table-column>
								<el-table-column
									prop="amount"
									align="center"
									label="消费金额"
									width="90">
								</el-table-column>
								<el-table-column
									prop="before"
									align="center"
									label="消费前余额"
									width="90">
								</el-table-column>
								<el-table-column
									prop="after"
									align="center"
									label="消费后余额"
									width="90">
								</el-table-column>
								<el-table-column
									prop="pay_type"
									align="center"
									label="消费方式"
									width="90">
								</el-table-column>
								<el-table-column
									prop="pay_status"
									align="center"
									label="支付状态"
									width="80">
								</el-table-column>
								<el-table-column
									prop="created_at"
									align="center"
									label="订单创建时间"
									min-width="160">
								</el-table-column>
							</template>
							<!-- 赠送余额列 (type=3) -->
							<template v-if="activeTab === 2">
								<el-table-column
									prop="no"
									align="center"
									label="订单号"
									min-width="160">
								</el-table-column>
								<el-table-column
									prop="amount"
									align="center"
									label="赠送金额"
									width="90">
								</el-table-column>
								<el-table-column
									prop="before"
									align="center"
									label="赠送前余额"
									width="90">
								</el-table-column>
								<el-table-column
									prop="after"
									align="center"
									label="赠送后余额"
									width="90">
								</el-table-column>
								<el-table-column
									prop="created_at"
									align="center"
									label="订单创建时间"
									min-width="160">
								</el-table-column>
							</template>
							<!-- 赠送套餐列 (type=4) -->
							<template v-if="activeTab === 3">
								<el-table-column
									prop="product_name"
									align="center"
									label="套餐名称"
									min-width="140">
								</el-table-column>
								<el-table-column
									prop="no"
									align="center"
									label="订单号"
									min-width="160">
								</el-table-column>
								<el-table-column
									prop="created_at"
									align="center"
									label="订单创建时间"
									min-width="160">
								</el-table-column>
							</template>
						</el-table>
						<el-pagination 
							background 
							layout="prev, pager, next, sizes, total, jumper"
							:page-sizes="[5, 10, 15, 20]"
							:page-size="pagesize"
							:total="current"
							@current-change="handleCurrentChange" 
							@size-change="handleSizeChange" 
						>
						</el-pagination>
					</div>
				</div>
			</template>
		</div>
  </div>
</template>

<script>
import { request } from "../../css/request.js";
import { Apis } from "../../css/Api.js";
export default {
	name:'record',
	data(){
		return {
			msg: 8888,
			list: [],
			pagesize: 10,
			currpage: 1,
			infoData:null,
			current:0,
			loading: true,
			// Tab 相关
			tabList: [
				{ name: '充值', type: 1 },
				{ name: '订单', type: 2 },
				{ name: '赠送余额', type: 3 },
				{ name: '赠送套餐', type: 4 }
			],
			activeTab: 0, // 默认选中充值
			apiMap: [
				Apis.getConsumeList, // 充值
				Apis.getConsumeList, // 订单
				Apis.getConsumeList, // 赠送余额
				Apis.getConsumeList // 赠送套餐
			]
		}
	},
	created(){
		this.getInfoData()
		this.getListData()
	},
	methods:{
		// Tab 切换
		switchTab(index) {
			this.activeTab = index;
			this.currpage = 1;
			this.getListData();
		},
		handleCurrentChange(cpage) {
			this.currpage = cpage;
			this.getListData()
		},
		handleSizeChange(psize) {
			this.pagesize = psize;
			this.getListData()
		},
		handleSelectionChange(val) {
		},
		jumpTopup(){
			this.$router.push({ path: '/topup' })
		},
		getInfoData(){
			let access_token = localStorage.getItem('access_token')
			let data = {
				access_token:access_token
			}
			request({
				method: 'get', 
				url: Apis.readMemberInfo,
				params:data
			}).then(res => {
				if(res.code == 0){
					this.infoData = res.data
					this.$store.commit("setMineData", res.data);
				}else{
					this.$message.error(res.msg);
				}
			});
		},
		getListData(){
			let access_token = localStorage.getItem('access_token')
			let data = {
				access_token:access_token,
				page:this.currpage,
				page_size:this.pagesize,
				type: this.tabList[this.activeTab].type // 传递 type 参数
			}
			// 根据 activeTab 选择不同接口
			const apiUrl = this.apiMap[this.activeTab];
			
			request({
				method: 'get', 
				url: apiUrl,
				params:data
			}).then(res => {
				if(res.code == 0){
					this.list = res.data.data || []
					this.current = res.data.total || 0
				}else{
					this.$message.error(res.msg);
					this.list = []
					this.current = 0
				}
				this.loading = false
			}).catch(() => {
				this.loading = false
				this.list = []
				this.current = 0
			});
		}
	},

}
</script>

<style lang="less" scoped>
.RecordBox{
	width: 100%;
	.Record{
		width: 100%;
		min-height: 880px;
		._RecordTop{
			width: 100%;
			height: 210px;
			background: #fff;
			padding: 36px;
			text-align: left;
			position: relative;
			._Record_p1{
				font-size: 18px;
				color:#1E1D1D;
				padding-left: 20px;
				margin-top: 20px;
			}
			._Record_p2{
				font-size: 48px;
				font-weight: bold;
				color: #D44F8D;
				padding-left: 20px;
				margin-top: 15px;
			}
			._Record_p_button{
				display: inline-block;
				width: 120px;
				height: 50px;
				border-radius: 6px;
				background: #1F8EFF;
				color: #fff;
				font-weight: bold;
				text-align: center;
				line-height: 50px;
				position: absolute;
				cursor:pointer;
				right: 20px;
				bottom: 20px;
			}
		}
		._RecordBot{
			width: 100%;
			min-height: calc(100% - 240px);
			background: #fff;
			margin-top: 30px;
			padding: 36px;
			
			._tabBox {
				display: flex;
				gap: 12px;
				margin-top: 20px;
				margin-bottom: 20px;
				
				._tab {
					padding: 10px 24px;
					background: #F5F7FA;
					border-radius: 4px;
					font-size: 14px;
					color: #666;
					cursor: pointer;
					transition: all 0.3s ease;
					
					&:hover {
						color: #1F8EFF;
					}
					
					&._active {
						background: #1F8EFF;
						color: #FFFFFF;
					}
				}
			}
			
			._cont{
				margin-top: 20px;
				
				// 简洁表格样式
				.clean-table {
					::v-deep .el-table__header th {
						background-color: #fafafa;
						color: #666;
						font-weight: 500;
						font-size: 14px;
						padding: 12px 0;
					}
					
					::v-deep .el-table__row td {
						padding: 16px 0;
						color: #333;
						font-size: 14px;
					}
					
					::v-deep .el-table__row:hover {
						background-color: #fafafa;
					}
					
					// 保留左右边框，去掉上下边框
					::v-deep .el-table::before {
						height: 0;
					}
					
					::v-deep .el-table th,
					::v-deep .el-table td {
						border-left: 1px solid #ebeef5;
						border-right: 1px solid #ebeef5;
						border-top: none;
						border-bottom: 1px solid #ebeef5;
					}
					
					// 表格外边框
					::v-deep .el-table {
						border-left: 1px solid #ebeef5;
						border-right: 1px solid #ebeef5;
						border-top: 1px solid #ebeef5;
						border-bottom: 1px solid #ebeef5;
					}
				}
				
				.el-pagination{
					margin-top: 20px;
				}
			}
		}
	}
}
._label{
	text-align: left;
	padding-left: 10px;
	position: relative;
	line-height: 30px;
	font-weight: bold;
	font-size: 20px;
	left: 10px;
}
._label::after{
	content: '';
	display: inline-block;
	width: 4px;
	height: 23px;
	background: #51B3FF;
	position: absolute;
	top: 5px;
	left: 0px;
}
</style>
